<template>
  <jin-popover placement="bottom-start" :open-delay="300" popper-class="ushk-company-popover" v-model="visible" trigger="click"
    transition="zoom-in-bottom" :popper-options="popperOptions" is-remove-slot>
    <div v-loading="isLoading" class="ushk-company">
      <template v-if="datas.length">
        <ushk-message v-if="datas.length" v-for="data in datas" :key="data.id" :data="data" :is-show-company-list="false"/>
      </template>
      <div class="ushk-company_none" v-else>暂无数杮</div>
    </div>
    <span slot="reference">
      <slot></slot>
    </span>
  </jin-popover>
</template>

<script>
  import { filterData, dataSplicing } from './filter'
  import { fetch } from '@/commons/fetch'
  import { requestUrl } from '@/commons/config'
  export default {
    name: '',
    props: {
      name: String
    },
    data () {
      return {
        visible: false,
        isLoading: true,
        datas: [],
        popperOptions: {
          gpuAcceleration: false,
          removeOnDestroy: true
        }
      }
    },
    watch: {
      visible (v, ov) {
        if (v) {
          this.render()
        }
      }
    },
    beforeCreate () {
      this.$options.components.UshkMessage = require('./Message')
    },
    methods: {
      render () {
        this.getList().then((datas) => {
          this.datas = dataSplicing(datas)
        })
      },
      getList () {
        return new Promise((resolve, reject) => {
          this.isLoading = true
          fetch({
            url: requestUrl.home.company,
            params: {
              keyword: this.name,
              max_time: 0
            },
            type: 'jsonp',
            jsonpCallback: 'callback',
            callback: (res) => {
              this.isLoading = false
            },
            success: (res) => {
              resolve(res.data)
            },
            error: () => {
              this.isLoading = false
            }
          })
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// CompanyList.vue?a68cae32